import { render, staticRenderFns } from "./AdherenceIndicatorsHeaderGDI.vue?vue&type=template&id=d64892c0&scoped=true&"
import script from "./AdherenceIndicatorsHeaderGDI.vue?vue&type=script&lang=js&"
export * from "./AdherenceIndicatorsHeaderGDI.vue?vue&type=script&lang=js&"
import style0 from "./AdherenceIndicatorsHeaderGDI.vue?vue&type=style&index=0&id=d64892c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64892c0",
  null
  
)

export default component.exports